export default __webpack_public_path__ + "static/media/fa-unlock-alt.9e02f979.png";